<div style = "margin-top: -2rem;">
  <div class="filter--checkboxes">
    <c11n-checkbox-group>
      <c11n-checkbox
        *ngFor="let label of regionFilterLabels"
        [labelText]="filterMap[label]"
        [variant]="'default'"
        [labelWeight]="'normal'">
        <input
          c11nCheckboxInput
          [formControl]="regionFilterGroup.controls[label]"
          [id]="label"
          type="checkbox"
          [name]="label"
          [value]="label" />
      </c11n-checkbox>
    </c11n-checkbox-group>
  </div>
</div>
